import { Stack, Text, Title } from "@assetwatch/ui";

export function FeaturesSection() {
  return (
    <Stack gap={16}>
      <Stack gap={4}>
        <Title size="md">Features</Title>
        <Text tone="subtle">
          Administrators configure approved features for this site here.
        </Text>
      </Stack>
      <Text tone="subtle">
        No features are available for configuration yet.
      </Text>
    </Stack>
  );
}
